import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsReloadPageService {
  public hasVisited = false;
  constructor() {}

  public checkPage() {
    this.hasVisited = true;
  }

  public isOpenPanelEvents = false;
  public checkOpenPanelEvents() {
    this.isOpenPanelEvents = true;
  }
  public checkClosePanelEvents() {
    this.isOpenPanelEvents = false;
  }
}
